import * as htmlToImage from 'html-to-image';
import { Compress } from './fileManager';

function timeout(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

async function sleep() {
  await timeout(2000);
  return true;
}

export async function PrintElement(replica, master, autosize = true) {
  const minimumSize = 40000;
  if (!master) {
    var aba = document.getElementById("aba_replica_" + replica.width + "x" + replica.height);
    aba.click();
    await sleep();
  }
  var div = document.getElementById("replica_" + replica.width +"x" + replica.height + "_backup");

  if (master) div.style.display = "block";
  var b64 =  await toImage(div, 1, "png");
  var compressedB64 = b64;
  var size = getBase64Size(compressedB64);
  if (autosize) {
    if (size > minimumSize) {
      for (var i = 10; i > 0; i--) {
        compressedB64 = await Compress(b64, i * 10);
        size = getBase64Size(compressedB64);
        if (size < minimumSize) break;
      }
    }
  }
  if (master) div.style.display = "none";
  return compressedB64;
}

async function toImage(div, quality, type = "jpeg") {
  return new Promise((resolve) => {
    if (type === "jpeg") {
      htmlToImage.toJpeg(div, { quality: quality, pixelRatio: 1 })
      .then(function (dataUrl) {
        resolve(dataUrl);
      });      
    } else if (type === "png") {
      htmlToImage.toPng(div, { quality: 1, pixelRatio: 1 })
      .then(function (dataUrl) {
        resolve(dataUrl);
      });    
    }
  })
}

export async function PrintDiv(id) {
  var div = document.getElementById(id);
  return await toImage(div, 1, "png");
}

var getBase64Size = function (base64) {
  var n = base64.length;
  var last = base64[n - 2];
  var y = 1;
  if (last === "=") y = 2;
  var x = (n * (3/4)) - y;
  return x;
};

export async function resizedataURL(datas, wantedWidth, wantedHeight) {
  return new Promise((resolve) => {
    var img = document.createElement('img');
    img.onload = function()
      {        
        var canvas = document.createElement('canvas');
        var ctx = canvas.getContext('2d');
  
        canvas.width = wantedWidth;
        canvas.height = wantedHeight;
  
        ctx.drawImage(this, 0, 0, wantedWidth, wantedHeight);
        resolve(canvas.toDataURL("image/png", 1));
      };
  
    img.src = datas;
  })
}